import checkoutSlice from "./checkoutDataSlice.js";
import { combineSlices } from "@reduxjs/toolkit";

const checkoutReducer = combineSlices({
  checkoutData: checkoutSlice.reducer,
});

export default checkoutReducer;
